import { AfterViewInit, Component, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core'
import { TranslateService } from '@app/shared/services/translate'
import locales from './locales'
import { Subject, takeUntil } from 'rxjs'
import { NgScrollbar } from 'ngx-scrollbar'
import { IScrollbarEvent, ScrollbarService } from '@app/shared/components/scrollbar'
import { IOrganization } from '@app/shared/data-types/organization.interface'
import { CurrentUser } from '@app/shared/services/current-user'
import { ACLService } from '@app/shared/services/acl'
import { Optional } from '@app/shared/data-types/optional.types'
import { ThemeService } from '@app/shared/services/theme'
import { ThemeTypes } from '@app/shared/data-types/user.interface'
import { createSubdomainOrigin } from '@app/shared/helpers/url.helpers'
import { environment } from '@env/environment'

@Component({
  selector: 'organizations-menu',
  templateUrl: './organizations-menu.component.html',
  standalone: false,
})
export class OrganizationsMenuComponent implements AfterViewInit, OnDestroy, OnChanges {
  constructor(
    public currentUser: CurrentUser,
    public ACLService: ACLService,
    private translate: TranslateService,
    private scrollbarService: ScrollbarService,
    private themeService: ThemeService
  ) {}
  t = this.translate.create(locales)

  @ViewChild(NgScrollbar) scrollbarRef: NgScrollbar

  @Input() currentOrg: IOrganization

  destroy$ = new Subject<void>()

  logoUrl: Optional<string>
  currentTheme: ThemeTypes

  ngOnInit(): void {
    this.themeService
      .get()
      .pipe(takeUntil(this.destroy$))
      .subscribe((theme) => {
        this.currentTheme = theme
        this.setLogo()
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('currentOrg' in changes) {
      this.setLogo()
    }
  }

  setLogo(): void {
    this.logoUrl = this.currentTheme == ThemeTypes.DARK ? this.currentOrg.dark_logo_url : this.currentOrg.logo_url
  }

  getOrgIndexLink(org: IOrganization): string {
    const origin = environment.production
      ? createSubdomainOrigin(org.subdomain || 'app', window.location)
      : window.location.origin
    if (org.default_module == 'screen') {
      return `${origin}/recorder/org/${org.id}/library`
    }

    return `${origin}/org/${org.id}/daily`
  }

  ngAfterViewInit(): void {
    this.scrollbarService.add(this.scrollbarRef)

    this.scrollbarRef.scrolled.pipe(takeUntil(this.destroy$)).subscribe((v) => {
      const event: IScrollbarEvent = {
        isScrolling: true,
        el: this.scrollbarRef.nativeElement,
      }
      this.scrollbarService.scrolling(event)
    })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.scrollbarService.remove(this.scrollbarRef)
  }
}
